<template>
  <BreadCrumb PageTitle="Colis du stock" />
  <StockColis />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import StockColis from "../../components/Stock/StockColis.vue";

export default defineComponent({
  name: "StockColisPage",
  components: {
    BreadCrumb,
    StockColis,
  },
});
</script>